<template>
    <v-container fluid>
       
        <!-- Breadcrumbs -->
        <v-breadcrumbs
            :items="[{text: 'Home', disable: false, href: '/#/'}, {text: 'Plants', disable: false, href: '/#/plants'}, {text: plant.name, disabled: true}]"
            divider="/"
            class="pb-0"
        ></v-breadcrumbs>

        <PlantDetailComponent
            :plantNodeId="$route.params.id"
            v-on:item-fetched="onPlantFecthed"
            v-on:item-deleted="onPlantDeleted"
        ></PlantDetailComponent>
    </v-container>
</template>

<script>
import PlantDetailComponent from "@/components/plants/PlantDetailComponent.vue";

export default {
    name: "plant-detail-page",
    components: {PlantDetailComponent
    },
    data() {
        return {
            plant: {}
        };
    },
    computed: {
    },
    watch: {},
    created() {
    },
    methods: {
        
        onPlantFecthed(response) {
            this.plant = response;
        },
        onPlantDeleted() {
            // redirect to plants list page
            this.$router.push("/plants");
        }
    }
};
</script>